import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SelectorStateService {
  private currentOpenSelector: string | null = null;
  private subscribers: { [key: string]: (isOpen: boolean) => void } = {};

  register(id: string, callback: (isOpen: boolean) => void) {
    this.subscribers[id] = callback;
  }

  unregister(id: string) {
    delete this.subscribers[id];
  }

  setOpenSelector(id: string | null) {
    if (id !== null && this.currentOpenSelector !== null && this.currentOpenSelector !== id) {
      const callback = this.subscribers[this.currentOpenSelector];
      if (callback) {
        callback(false);
      }
    }
    this.currentOpenSelector = id;
  }

  isCurrentOpenSelector(id: string): boolean {
    return this.currentOpenSelector === id;
  }
} 